__turbopack_context__.v({
  "bgImage": "SlideShow-module-scss-module__GQDanG__bgImage",
  "dots": "SlideShow-module-scss-module__GQDanG__dots",
  "dotsOnLeft": "SlideShow-module-scss-module__GQDanG__dotsOnLeft",
  "image": "SlideShow-module-scss-module__GQDanG__image",
  "imageWrapper": "SlideShow-module-scss-module__GQDanG__imageWrapper",
  "initial": "SlideShow-module-scss-module__GQDanG__initial",
  "isReady": "SlideShow-module-scss-module__GQDanG__isReady",
  "root": "SlideShow-module-scss-module__GQDanG__root",
  "slide": "SlideShow-module-scss-module__GQDanG__slide",
  "slide-fade-in": "SlideShow-module-scss-module__GQDanG__slide-fade-in",
  "slide-fade-in-user": "SlideShow-module-scss-module__GQDanG__slide-fade-in-user",
  "track": "SlideShow-module-scss-module__GQDanG__track",
  "user": "SlideShow-module-scss-module__GQDanG__user",
});
